'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint-disable indent */


var _webComponents = require('@vezeeta/web-components');

var _Helpers = require('@vezeeta/enterprise-utils/lib/Helpers');

var _Constants = require('@vezeeta/enterprise-utils/lib/Constants');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _language = require('../types/language');

var _enum = require('../enum');

var _appointments2 = require('../actions/appointments');

var _appointments3 = require('../types/appointments');

var _appointments4 = _interopRequireDefault(_appointments3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var initialState = {
  appointments: _webComponents.renderer.loading(),
  appointmentsList: [],
  showMore: { isLoading: false, enable: false },
  appointmentsUpdates: null,
  appointmentsListUpdates: [],
  showMoreUpdates: { isLoading: false, enable: false },
  hasNewUpdates: false,

  isCalendarEmpty: false,
  isFilterEmpty: false,
  selected: {
    roomsAndDoctors: [],
    patientKey: '',
    hasDoctors: true,
    startDate: (0, _Helpers.getFormattedDate)(new Date()),
    endDate: (0, _Helpers.getFormattedDate)((0, _Helpers.getDateAfterGivenDays)(6))
  },
  createAppointment: {
    appointmentDetails: {},
    isFetching: false,
    isSuccess: false,
    isFail: { isError: false, message: '' },
    createAppointmentState: _enum.status.SHOULD_CALL_API
  },
  cancelAppointment: {
    isFetching: false,
    isSuccess: false,
    isFail: { isError: false, message: '' }
  },
  markAsNoShowAppointment: {
    isFetching: false,
    isSuccess: false,
    isFail: { isError: false, message: '' }
  },
  markAsInsuredAppointment: {
    isFetching: false,
    isSuccess: false,
    isFail: { isError: false, message: '' }
  },
  addPrescription: {
    isFetching: false,
    isSuccess: false,
    isFail: { isError: false, message: '' }
  },
  addPrescriptionLoadStatus: _enum.status.SHOULD_CALL_API,
  snackBar: { show: false, message: '' },
  cancelAppointmentModal: { isOpen: false, appointmentDetails: {} },
  editAppointmentModal: { isOpen: false, appointmentDetails: {} },
  printInvoiceModal: { isOpen: false, printInvoiceDetails: {} },
  markAsNoShowModal: { isOpen: false, appointmentDetails: {} },
  confirmationModal: { isOpen: false },
  markAsInsuredModal: { isOpen: false, appointmentDetails: {} },
  addAppointmentModal: { isOpen: false },
  addPrescriptionModal: { isOpen: false, appointmentDetails: {} },
  rescheduleModal: { isOpen: false, appointmentDetails: {} },
  addAppointmentDetails: {},
  addAppointmentDetailsStatus: _enum.status.SHOULD_CALL_API,
  editAppointmentDetailsStatus: _enum.status.SHOULD_CALL_API,
  nationalId: {
    patientNationalId: {},
    status: _enum.status.SHOULD_CALL_API
  },
  appointmentInvoiceDetails: {},
  appointmentInvoiceDetailsStatus: _enum.status.SHOULD_CALL_API,
  insuranceCard: {
    patientInsuranceCard: {},
    status: _enum.status.SHOULD_CALL_API
  },
  uploadNationalIdStatus: _enum.status.SHOULD_CALL_API,
  countReservationStatus: _enum.status.SHOULD_CALL_API,
  countReservation: undefined,
  approvalLetter: {
    patientApprovalLetter: {},
    status: _enum.status.SHOULD_CALL_API
  },
  uploadApprovalLetterStatus: _enum.status.SHOULD_CALL_API,
  lastUploadedPrescription: undefined
};

var changeAppointmentState = function changeAppointmentState(appointments, appointmentKey, newState) {
  return appointments.map(function (appointment) {
    return appointment.ReservationKey === appointmentKey ? _extends({}, appointment, newState) : appointment;
  });
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];

  var type = _ref.type,
      payload = _objectWithoutProperties(_ref, ['type']);

  switch (type) {
    case _appointments2.APPOINTMENTS.FETCH_COUNT_RESERVATION.LOAD:
      return _extends({}, state, {
        countReservationStatus: _enum.status.FETCHING,
        countReservation: undefined
      });
    case _appointments2.APPOINTMENTS.FETCH_COUNT_RESERVATION.SUCCESS:
      return _extends({}, state, {
        countReservationStatus: _enum.status.SUCCESS,
        countReservation: payload.payload
      });
    case _appointments2.APPOINTMENTS.FETCH_COUNT_RESERVATION.FAIL:
      return _extends({}, state, {
        countReservationStatus: _enum.status.FAIL,
        countReservation: payload
      });
    case _appointments2.APPOINTMENTS.GET_APPOINTMENT_INVOICE.LOAD:
      return _extends({}, state, {
        appointmentInvoiceDetails: {},
        appointmentInvoiceDetailsStatus: _enum.status.FETCHING
      });
    case _appointments2.APPOINTMENTS.GET_APPOINTMENT_INVOICE.SUCCESS:
      return _extends({}, state, {
        appointmentInvoiceDetails: payload,
        appointmentInvoiceDetailsStatus: _enum.status.SUCCESS
      });

    case _appointments2.APPOINTMENTS.GET_APPOINTMENT_INVOICE.FAIL:
      return _extends({}, state, {
        appointmentInvoiceDetails: payload,
        appointmentInvoiceDetailsStatus: _enum.status.FAIL
      });
    case _appointments2.APPOINTMENTS.ADD_APPOINTMENT.SUBMIT:
      return _extends({}, state, {
        addAppointmentDetailsStatus: _enum.status.SUBMITING
      });
    case _appointments2.APPOINTMENTS.ADD_APPOINTMENT.SUCCESS:
      {
        var getAppointmentTypes = {
          0: 'Examination',
          1: 'followUpVisit',
          3: 'services'
        };
        return _extends({}, state, {
          addAppointmentDetails: payload,
          addAppointmentDetailsStatus: _enum.status.SUCCESS,
          printInvoiceModal: {
            isOpen: state.printInvoiceModal.isOpen,
            printInvoiceDetails: _extends({
              reservationKey: payload.payload && payload.payload[0] && payload.payload[0].ReservationKey,
              branchKey: payload.payload && payload.payload[0] && payload.payload[0].BranchKey,
              component: 'Add appointment',
              appointmentType: getAppointmentTypes[payload.payload && payload.payload[0] && payload.payload[0].VisitType]
            }, payload)
          }
        });
      }
    case _appointments2.APPOINTMENTS.ADD_APPOINTMENT.FAILED:
      return _extends({}, state, {
        addAppointmentDetailsStatus: _enum.status.FAIL
      });
    case _appointments2.APPOINTMENTS.EDIT_APPOINTMENT.SUBMIT:
      return _extends({}, state, {
        editAppointmentDetailsStatus: _enum.status.SUBMITING
      });
    case _appointments2.APPOINTMENTS.EDIT_APPOINTMENT.SUCCESS:
      return _extends({}, state, {
        editAppointmentDetailsStatus: _enum.status.SUCCESS
      });
    case _appointments2.APPOINTMENTS.EDIT_APPOINTMENT.FAILED:
      return _extends({}, state, {
        editAppointmentDetailsStatus: _enum.status.FAIL
      });
    case _appointments2.APPOINTMENTS.FETCH.LOAD:
      if (!payload.pushToCurrent) {
        return _extends({}, state, {
          appointments: _webComponents.renderer.loading()
        });
      }
      return _extends({}, state, {
        showMore: {
          isLoading: true,
          enable: true
        }
      });
    case _appointments2.APPOINTMENTS.FETCH_UPDATES.LOAD:
      return _extends({}, state, {
        showMoreUpdates: {
          isLoading: true,
          enable: true
        }
      });

    case _appointments2.APPOINTMENTS.FETCH.SUCCESS:
      {
        var appointmentsList = [];
        var appointments = void 0;
        var showMore = void 0;

        if (payload.pushToCurrent) {
          appointmentsList = [].concat(state.appointmentsList, payload.appointments);
        } else {
          appointmentsList = payload.appointments;
        }

        if (payload.appointments.length > 0) {
          appointments = _webComponents.renderer.success(appointmentsList);
          showMore = {
            isLoading: false,
            enable: payload.appointments.length === _Constants.PAGE_SIZE
          };
        } else {
          showMore = { isLoading: false, enable: false };

          if (!payload.pushToCurrent) {
            appointments = _webComponents.renderer.empty(_appointments4.default.NO_APPOINTMENTS);
          } else {
            appointments = _webComponents.renderer.success(appointmentsList);
          }
        }

        return _extends({}, state, {
          appointments: appointments,
          appointmentsList: appointmentsList,
          showMore: showMore
        });
      }

    case _appointments2.APPOINTMENTS.FETCH_UPDATES.SUCCESS:
      {
        var appointmentsListUpdates = [];
        var appointmentsUpdates = void 0;
        var showMoreUpdates = void 0;
        var hasNewUpdates = false;

        appointmentsListUpdates = payload.appointments;

        if (payload.appointments.length > 0 && !_lodash2.default.isEqual(state.appointmentsList, appointmentsListUpdates) && appointmentsListUpdates.length > state.appointmentsList.length) {
          appointmentsUpdates = _webComponents.renderer.success(appointmentsListUpdates);
          showMoreUpdates = {
            isLoading: false,
            enable: payload.appointments.length === _Constants.PAGE_SIZE
          };
          hasNewUpdates = true;
        } else {
          showMoreUpdates = { isLoading: false, enable: false };
          appointmentsUpdates = _webComponents.renderer.success(appointmentsListUpdates);
        }

        return _extends({}, state, {
          appointmentsUpdates: appointmentsUpdates,
          appointmentsListUpdates: appointmentsListUpdates,
          showMoreUpdates: showMoreUpdates,
          hasNewUpdates: hasNewUpdates
        });
      }

    case _appointments2.APPOINTMENTS.FETCH.FAIL:
      return _extends({}, state, { appointments: _webComponents.renderer.failure(payload.error) });

    case _appointments2.APPOINTMENTS.FETCH_UPDATES.FAIL:
      return _extends({}, state, {
        appointmentsUpdates: _webComponents.renderer.failure(payload.error),
        hasNewUpdates: false
      });

    case _appointments2.APPOINTMENTS.LOAD_APPOINTMENTS_UPDATES:
      return _extends({}, state, {
        appointments: state.appointmentsUpdates,
        appointmentsList: state.appointmentsListUpdates,
        showMore: state.showMoreUpdates,
        hasNewUpdates: false
      });

    case _appointments2.APPOINTMENTS.CLOSE_APPOINTMENTS_NOTIFICATION_BAR:
      return _extends({}, state, {
        hasNewUpdates: false
      });

    case _appointments2.APPOINTMENTS.FILTER.SET_SELECTED_DATES:
      {
        if (!payload.dates.startDate || !payload.dates.endDate) {
          return _extends({}, state, {
            isCalendarEmpty: true,
            appointments: _webComponents.renderer.empty(_appointments4.default.EMPTY_CALENDAR),
            selected: _extends({}, state.selected, {
              startDate: payload.dates.startDate,
              endDate: payload.dates.endDate
            })
          });
        }

        var hasDoctors = state.selected.hasDoctors;
        var _appointments = state.appointments;

        if (!hasDoctors) {
          _appointments = _webComponents.renderer.empty(_appointments4.default.NO_USERS);
        }

        return _extends({}, state, {
          isCalendarEmpty: false,
          appointments: _appointments,
          selected: _extends({}, state.selected, {
            startDate: payload.dates.startDate,
            endDate: payload.dates.endDate
          })
        });
      }

    case _appointments2.APPOINTMENTS.FILTER.SET_SELECTED_ROOMS_AND_DOCTORS:
      {
        if (payload.roomsAndDoctors.length > 0) {
          return _extends({}, state, {
            isFilterEmpty: false,
            selected: _extends({}, state.selected, {
              roomsAndDoctors: payload.roomsAndDoctors,
              hasDoctors: payload.hasDoctors
            })
          });
        }

        return _extends({}, state, {
          isFilterEmpty: true,
          appointments: _webComponents.renderer.empty(payload.hasDoctors ? _appointments4.default.EMPTY_FILTER : _appointments4.default.NO_USERS),
          selected: _extends({}, state.selected, {
            hasDoctors: payload.hasDoctors,
            roomsAndDoctors: payload.data
          })
        });
      }

    case _appointments2.APPOINTMENTS.FILTER.SET_PATIENT_NAME:
      return _extends({}, state, {
        selected: _extends({}, state.selected, { patientKey: payload.patientKey })
      });

    case _appointments2.APPOINTMENTS.CREATE.LOAD:
      return _extends({}, state, {
        createAppointment: {
          isFetching: true,
          isSuccess: false,
          isFail: { isError: false, message: '' },
          createAppointmentState: _enum.status.SUBMITING
        }
      });

    case _appointments2.APPOINTMENTS.CREATE.SUCCESS:
      {
        // const newAppointmentList = state.appointmentsList;
        /* const { ReservationKey, oldReservationKey } = payload.appointment;
         newAppointmentList.unshift(payload.appointment);
         if (oldReservationKey) {
          const oldRescheduledAppointment = newAppointmentList.filter(
            appointment => appointment.ReservationKey === oldReservationKey,
          );
        } */

        return _extends({}, state, {
          createAppointment: _extends({}, state.createAppointment, {
            isFetching: false,
            isSuccess: true,
            isFail: { isError: false, message: '' },
            createAppointmentState: _enum.status.SUCCESS
          }),
          snackBar: {
            show: true,
            message: _language.language === 'en' ? 'Appointment created successfully' : 'تم إضافة الحجز بنجاح'
          },
          // appointments: renderer.success(newAppointmentList),
          // appointmentsList: newAppointmentList,
          addAppointmentModal: {
            isOpen: false
          },
          rescheduleModal: {
            isOpen: false
          }
        });
      }

    case _appointments2.APPOINTMENTS.CREATE.FAIL:
      return _extends({}, state, {
        createAppointment: {
          appointmentDetails: {},
          isFetching: false,
          isSuccess: false,
          isFail: { isError: true, message: payload.error },
          createAppointmentState: _enum.status.FAIL
        }
      });

    case _appointments2.APPOINTMENTS.CANCEL.LOAD:
      return _extends({}, state, {
        cancelAppointment: {
          isFetching: true,
          isSuccess: false,
          isFail: { isError: false, message: '' }
        }
      });

    case _appointments2.APPOINTMENTS.CANCEL.SUCCESS:
      {
        var _appointmentsList = state.appointmentsList.map(function (appointment) {
          return appointment.ReservationKey === payload.appointmentKey ? _extends({}, appointment, { IsCancelled: true, EnableEditReservation: false }) : appointment;
        });

        return _extends({}, state, {
          appointments: _webComponents.renderer.success(_appointmentsList),
          appointmentsList: _appointmentsList,
          cancelAppointment: {
            isFetching: false,
            isSuccess: true,
            isFail: { isError: false, message: '' }
          },
          cancelAppointmentModal: { isOpen: false, appointmentDetails: {} },
          snackBar: {
            show: true,
            message: _language.language === 'en' ? 'Appointment cancelled successfully' : 'تم إلغاء الحجز بنجاح'
          }
        });
      }

    case _appointments2.APPOINTMENTS.CANCEL.FAIL:
      return _extends({}, state, {
        cancelAppointment: {
          isFetching: false,
          isSuccess: false,
          isFail: { isError: true, message: '' }
        }
      });

    case _appointments2.APPOINTMENTS.MARK_AS_NO_SHOW.LOAD:
      return _extends({}, state, {
        markAsNoShowAppointment: {
          isFetching: true,
          isSuccess: false,
          isFail: { isError: false, message: '' }
        }
      });

    case _appointments2.APPOINTMENTS.MARK_AS_NO_SHOW.SUCCESS:
      {
        var _appointmentsList2 = state.appointmentsList.map(function (appointment) {
          return appointment.ReservationKey === payload.appointmentKey ? _extends({}, appointment, {
            IsNoShow: !payload.isNoShow,
            EnableEditReservation: !!payload.isNoShow
          }) : appointment;
        });
        var noShowMessage = _language.language === 'en' ? 'Appointment marked as No-show successfully' : 'تم تحديد المريض لم يحضر بنجاح';
        var undoNoShowMessage = _language.language === 'en' ? 'Appointment No-show removed successfully' : 'تم إزالة تحديد المريض كلم يحضر بنجاح';
        return _extends({}, state, {
          appointments: _webComponents.renderer.success(_appointmentsList2),
          appointmentsList: _appointmentsList2,
          markAsNoShowAppointment: {
            isFetching: false,
            isSuccess: true,
            isFail: { isError: false, message: '' }
          },
          markAsNoShowModal: { isOpen: false, appointmentDetails: {} },
          snackBar: {
            show: true,
            message: payload.isNoShow ? undoNoShowMessage : noShowMessage
          }
        });
      }

    case _appointments2.APPOINTMENTS.MARK_AS_NO_SHOW.FAIL:
      return _extends({}, state, {
        markAsNoShowAppointment: {
          isFetching: false,
          isSuccess: false,
          isFail: { isError: true, message: '' }
        }
      });

    case _appointments2.APPOINTMENTS.MARK_AS_INSURED.LOAD:
      return _extends({}, state, {
        markAsInsuredAppointment: {
          isFetching: true,
          isSuccess: false,
          isFail: { isError: false, message: '' }
        }
      });

    case _appointments2.APPOINTMENTS.MARK_AS_INSURED.SUCCESS:
      {
        var _appointmentsList3 = state.appointmentsList.map(function (appointment) {
          return appointment.ReservationKey === payload.appointmentKey ? _extends({}, appointment, { IsInsured: payload.isInsured === 1 }) : appointment;
        });
        var insuredMessage = _language.language === 'en' ? 'Appointment Marked as Insured Successfully' : 'تم تحديد المريض كمؤمن عليه بنجاح';
        var undoInsuredMessage = _language.language === 'en' ? 'Appointment insurance removed successfully' : 'تم إزالة التأمين من على الحجز بنجاح';
        return _extends({}, state, {
          appointments: _webComponents.renderer.success(_appointmentsList3),
          appointmentsList: _appointmentsList3,
          markAsInsuredAppointment: {
            isFetching: false,
            isSuccess: true,
            isFail: { isError: false, message: '' }
          },
          markAsInsuredModal: { isOpen: false, appointmentDetails: {} },
          snackBar: {
            show: true,
            message: payload.isInsured === 1 ? insuredMessage : undoInsuredMessage
          }
        });
      }

    case _appointments2.APPOINTMENTS.MARK_AS_INSURED.FAIL:
      return _extends({}, state, {
        markAsInsuredAppointment: {
          isFetching: false,
          isSuccess: false,
          isFail: { isError: true, message: '' }
        }
      });

    case _appointments2.APPOINTMENTS.CHECK_IN.LOAD:
      {
        var _appointmentsList4 = changeAppointmentState(state.appointmentsList, payload.appointmentKey, {
          isCheckingIn: true
        });
        return _extends({}, state, {
          appointmentsList: _appointmentsList4,
          appointments: _webComponents.renderer.success(_appointmentsList4)
        });
      }

    case _appointments2.APPOINTMENTS.CHECK_IN.SUCCESS:
      {
        var _appointmentsList5 = changeAppointmentState(state.appointmentsList, payload.appointmentKey, {
          isCheckingIn: false,
          IsCheckedIn: !payload.isCheckedIn
        });
        var checkInMessage = _language.language === 'en' ? 'Appointment Checked-in Successfully' : 'تم تسجيل الحضور بنجاح';
        var checkOutMessage = _language.language === 'en' ? 'Appointment check-in undone successfully' : 'تم إزالة تسجيل الحضور بنجاح';
        return _extends({}, state, {
          appointmentsList: _appointmentsList5,
          appointments: _webComponents.renderer.success(_appointmentsList5),
          snackBar: {
            show: true,
            message: !payload.isCheckedIn ? checkInMessage : checkOutMessage
          }
        });
      }

    case _appointments2.APPOINTMENTS.CHECK_IN.FAIL:
      {
        var _appointmentsList6 = changeAppointmentState(state.appointmentsList, payload.appointmentKey, {
          isCheckingIn: false,
          IsCheckedIn: false
        });
        return _extends({}, state, {
          appointmentsList: _appointmentsList6,
          appointments: _webComponents.renderer.success(_appointmentsList6)
        });
      }

    case _appointments2.APPOINTMENTS.MODAL.CANCEL_TOGGLE:
      return _extends({}, state, {
        cancelAppointmentModal: {
          isOpen: payload.isOpened,
          appointmentDetails: state.cancelAppointmentModal.appointmentDetails
        }
      });

    case _appointments2.APPOINTMENTS.MODAL.EDIT_APPOINTMENT_TOGGLE:
      return _extends({}, state, {
        editAppointmentModal: {
          isOpen: payload.isOpened,
          appointmentDetails: state.editAppointmentModal.appointmentDetails
        }
      });

    case _appointments2.APPOINTMENTS.MODAL.PRINT_INVOICE_TOGGLE:
      {
        return _extends({}, state, {
          printInvoiceModal: {
            isOpen: payload.isOpened,
            printInvoiceDetails: state.printInvoiceModal.printInvoiceDetails
          }
        });
      }

    case _appointments2.APPOINTMENTS.MODAL.SET_PRINT_INVOICE_DETAILS:
      return _extends({}, state, {
        printInvoiceModal: {
          isOpen: state.printInvoiceModal.isOpen,
          printInvoiceDetails: payload.payload
        }
      });

    case _appointments2.APPOINTMENTS.MODAL.SET_CANCEL_APPOINTMENT_DETAILS:
      return _extends({}, state, {
        cancelAppointmentModal: {
          isOpen: state.cancelAppointmentModal.isOpen,
          appointmentDetails: payload.appointmentDetails
        }
      });

    case _appointments2.APPOINTMENTS.MODAL.EDIT_APPOINTMENT:
      return _extends({}, state, {
        editAppointmentModal: {
          isOpen: state.editAppointmentModal.isOpen,
          appointmentDetails: payload.appointmentDetails
        }
      });

    case _appointments2.APPOINTMENTS.MODAL.NO_SHOW_TOGGLE:
      return _extends({}, state, {
        markAsNoShowModal: {
          isOpen: payload.isOpened,
          appointmentDetails: state.markAsNoShowModal.appointmentDetails
        }
      });

    case _appointments2.APPOINTMENTS.MODAL.CONFIRMATION:
      return _extends({}, state, {
        confirmationModal: {
          isOpen: payload.isOpened
        }
      });

    case _appointments2.APPOINTMENTS.MODAL.SET_NO_SHOW_APPOINTMENT_DETAILS:
      return _extends({}, state, {
        markAsNoShowModal: {
          isOpen: state.markAsNoShowModal.isOpen,
          appointmentDetails: payload.appointmentDetails
        }
      });

    case _appointments2.APPOINTMENTS.MODAL.INSURED_TOGGLE:
      return _extends({}, state, {
        markAsInsuredModal: {
          isOpen: payload.isOpened,
          appointmentDetails: state.markAsInsuredModal.appointmentDetails
        }
      });

    case _appointments2.APPOINTMENTS.MODAL.SET_INSURED_APPOINTMENT_DETAILS:
      return _extends({}, state, {
        markAsInsuredModal: {
          isOpen: state.markAsInsuredModal.isOpen,
          appointmentDetails: payload.appointmentDetails
        }
      });

    case _appointments2.APPOINTMENTS.MODAL.ADD_APPOINTMENT_TOGGLE:
      return _extends({}, state, {
        addAppointmentModal: {
          isOpen: payload.isOpened
        }
      });

    case _appointments2.APPOINTMENTS.MODAL.SET_PRESCRIPTION_APPOINTMENT_DETAILS:
      return _extends({}, state, {
        addPrescriptionModal: {
          isOpen: state.addPrescriptionModal.isOpen,
          appointmentDetails: payload.appointmentDetails
        }
      });

    case _appointments2.APPOINTMENTS.MODAL.ADD_PRESCRIPTION_TOGGLE:
      return _extends({}, state, {
        addPrescriptionModal: {
          isOpen: payload.isOpened,
          appointmentDetails: state.addPrescriptionModal.appointmentDetails
        }
      });

    case _appointments2.APPOINTMENTS.MODAL.SET_RESCHEDULE_APPOINTMENT_DETAILS:
      return _extends({}, state, {
        rescheduleModal: {
          isOpen: state.rescheduleModal.isOpen,
          appointmentDetails: payload.appointmentDetails
        }
      });

    case _appointments2.APPOINTMENTS.MODAL.RESCHEDULE_TOGGLE:
      return _extends({}, state, {
        rescheduleModal: {
          isOpen: payload.isOpened,
          appointmentDetails: state.rescheduleModal.appointmentDetails
        }
      });

    case _appointments2.APPOINTMENTS.SNACK_BAR.HIDE:
      return _extends({}, state, {
        snackBar: {
          show: false,
          message: ''
        }
      });

    case _appointments2.APPOINTMENTS.ADD_PRESCRIPTION.LOAD:
      return _extends({}, state, {
        addPrescriptionLoadStatus: _enum.status.SUBMITING,
        addPrescription: {
          isFetching: true,
          isSuccess: false,
          isFail: { isError: false, message: '' }
        },
        lastUploadedPrescription: undefined
      });

    case _appointments2.APPOINTMENTS.ADD_PRESCRIPTION.SUCCESS:
      {
        var _appointmentsList7 = state.appointmentsList.map(function (appointment) {
          return appointment.ReservationKey === payload.appointmentKey ? _extends({}, appointment, { IsPrescriptionSubmitted: payload.imagesCount !== 0 }) : appointment;
        });
        var prescriptionMassage = payload.successMassage;

        return _extends({}, state, {
          appointmentsList: _appointmentsList7,
          appointments: _webComponents.renderer.success(_appointmentsList7),
          addPrescriptionLoadStatus: _enum.status.SUCCESS,
          addPrescription: {
            isFetching: false,
            isSuccess: true,
            isFail: { isError: false, message: '' }
          },
          addPrescriptionModal: { isOpen: false, appointmentDetails: {} },
          snackBar: {
            show: true,
            message: prescriptionMassage
          },
          lastUploadedPrescription: payload
        });
      }

    case _appointments2.APPOINTMENTS.ADD_PRESCRIPTION.FAIL:
      return _extends({}, state, {
        addPrescriptionLoadStatus: _enum.status.FAIL,
        addPrescription: {
          isFetching: false,
          isSuccess: false,
          isFail: { isError: true, message: '' }
        },
        snackBar: {
          show: true,
          message: payload.errorMassage
        },
        lastUploadedPrescription: undefined
      });

    case _appointments2.APPOINTMENTS.NATIONAL_ID.LOAD:
      return _extends({}, state, {
        nationalId: {
          patientNationalId: {},
          status: _enum.status.FETCHING
        }
      });

    case _appointments2.APPOINTMENTS.NATIONAL_ID.SUCCESS:
      return _extends({}, state, {
        nationalId: {
          patientNationalId: payload.data,
          status: _enum.status.SUCCESS
        }
      });
    case _appointments2.APPOINTMENTS.NATIONAL_ID.FAIL:
      return _extends({}, state, {
        nationalId: {
          patientNationalId: {},
          status: _enum.status.FAIL
        }
      });
    case _appointments2.APPOINTMENTS.NATIONAL_ID.RESET:
      return _extends({}, state, {
        nationalId: {
          patientNationalId: {},
          status: _enum.status.SHOULD_CALL_API
        }
      });

    case _appointments2.APPOINTMENTS.INSURANCE_CARD.LOAD:
      return _extends({}, state, {
        insuranceCard: {
          patientInsuranceCard: {},
          status: _enum.status.FETCHING
        }
      });

    case _appointments2.APPOINTMENTS.INSURANCE_CARD.SUCCESS:
      return _extends({}, state, {
        insuranceCard: {
          patientInsuranceCard: payload.data,
          status: _enum.status.SUCCESS
        }
      });

    case _appointments2.APPOINTMENTS.INSURANCE_CARD.FAIL:
      return _extends({}, state, {
        insuranceCard: {
          patientInsuranceCard: {},
          status: _enum.status.FAIL
        }
      });

    case _appointments2.APPOINTMENTS.UPLOAD_NATIONAL_ID.LOAD:
      return _extends({}, state, {
        uploadNationalIdStatus: _enum.status.FETCHING
      });

    case _appointments2.APPOINTMENTS.UPLOAD_NATIONAL_ID.SUCCESS:
      return _extends({}, state, {
        uploadNationalIdStatus: _enum.status.SUCCESS
      });

    case _appointments2.APPOINTMENTS.UPLOAD_NATIONAL_ID.FAIL:
      return _extends({}, state, {
        uploadNationalIdStatus: _enum.status.FAIL
      });

    case _appointments2.APPOINTMENTS.APPROVAL_LETTER.LOAD:
      return _extends({}, state, {
        approvalLetter: {
          patientApprovalLetter: {},
          status: _enum.status.FETCHING
        }
      });

    case _appointments2.APPOINTMENTS.APPROVAL_LETTER.SUCCESS:
      return _extends({}, state, {
        approvalLetter: {
          patientApprovalLetter: payload.data,
          status: _enum.status.SUCCESS
        }
      });

    case _appointments2.APPOINTMENTS.APPROVAL_LETTER.FAIL:
      return _extends({}, state, {
        approvalLetter: {
          patientApprovalLetter: {},
          status: _enum.status.FAIL
        }
      });

    case _appointments2.APPOINTMENTS.APPROVAL_LETTER.RESET:
      return _extends({}, state, {
        approvalLetter: {
          patientApprovalLetter: {},
          status: _enum.status.SHOULD_CALL_API
        }
      });

    case _appointments2.APPOINTMENTS.UPLOAD_APPROVAL_LETTER.LOAD:
      return _extends({}, state, {
        uploadApprovalLetterStatus: _enum.status.FETCHING
      });

    case _appointments2.APPOINTMENTS.UPLOAD_APPROVAL_LETTER.SUCCESS:
      return _extends({}, state, {
        uploadApprovalLetterStatus: _enum.status.SUCCESS
      });

    case _appointments2.APPOINTMENTS.UPLOAD_APPROVAL_LETTER.FAIL:
      return _extends({}, state, {
        uploadApprovalLetterStatus: _enum.status.FAIL
      });

    default:
      return state;
  }
};

module.exports = exports['default'];